<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
      <div>
        <img src="../public/img/theme/whatsapp.png" alt="" class="whatsapp" @click="whatsapp">
      </div>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition
  },
  mounted() {
    this.$ga.page('/');
  },
  methods: {
    whatsapp () {
      window.open('https://api.whatsapp.com/send?phone=22940361453', '_blank')
    }
  },
};
</script>
<style>
div{
  font-family: 'Poppins', 'PT Sans Caption';
}
.whatsapp{
  cursor: pointer;
  position: fixed;
  bottom: 50px;
  right: 30px;
  height: 50px;
}
.whatsapp:hover{
  height: 70px;
}
</style>
